import * as tslib_1 from "tslib";
import * as React from 'react';
import '../steps/index.css';
var StepRender = (function (_super) {
    tslib_1.__extends(StepRender, _super);
    function StepRender() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StepRender.prototype.render = function () {
        var _a = this.props, className = _a.className, current = _a.current, status = _a.status, children = _a.children;
        return (React.createElement("div", { className: className }, React.Children.map(children, function (item, index) {
            var curIndex = index + 1;
            var props = {
                isCurrent: curIndex === current,
                isLast: curIndex === React.Children.count(children),
                stepNum: curIndex,
                status: status
            };
            props.status = curIndex < current ?
                'finished' : curIndex === current ?
                status : 'wait';
            return React.cloneElement(item, props);
        })));
    };
    StepRender.defaultProps = {
        className: '',
        status: 'default',
        current: 1
    };
    return StepRender;
}(React.Component));
export default StepRender;
